import { useState } from "react";
import { toast } from "sonner";
import { Send, Mail, MapPin } from "lucide-react";
import { api } from "../lib/api";
import Reveal from "../components/Reveal";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Une erreur est survenue. Réessayez dans un instant.");
    } finally {
      setSending(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border border-jm-brass/25 focus:border-jm-amber px-4 py-3.5 text-sm text-jm-bone placeholder:text-jm-mute focus:outline-none transition-colors";

  return (
    <main data-testid="contact-page" className="pt-28 sm:pt-36">
      <div className="jm-container pb-24 sm:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-5">
            <p className="jm-overline mb-5">Contact</p>
            <p className="mt-6 text-jm-smoke leading-relaxed max-w-md">
              Une programmation, une question presse, une commande boutique, une envie de soutenir ?
              Nous lisons tout, et nous répondons vite.
            </p>
            <div className="mt-10 space-y-5">
              <a href="mailto:contact@joymessenger.fr" className="flex items-center gap-4 text-jm-smoke hover:text-jm-bone transition-colors">
                <Mail size={17} className="text-jm-amber" />
                <span className="text-sm">contact@joymessenger.fr</span>
              </a>
              <div className="flex items-center gap-4 text-jm-smoke">
                <MapPin size={17} className="text-jm-amber" />
                <span className="text-sm">Paris, France</span>
              </div>
            </div>
            <div className="mt-10 border border-jm-brass/15 bg-jm-card/50 p-6">
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-jm-mute mb-3">Contacts directs</p>
              <div className="space-y-2 text-sm text-jm-smoke">
                <p>Booking — booking@joymessenger.fr</p>
                <p>Presse — presse@joymessenger.fr</p>
                <p>Production — production@joymessenger.fr</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12} className="lg:col-span-7">
            <form onSubmit={submit} data-testid="contact-form" className="border border-jm-brass/15 bg-jm-card/60 p-7 sm:p-10 space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <input
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Votre nom"
                  data-testid="contact-name-input"
                  className={inputCls}
                />
                <input
                  required
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="Votre email"
                  data-testid="contact-email-input"
                  className={inputCls}
                />
              </div>
              <input
                value={form.subject}
                onChange={(e) => setForm({ ...form, subject: e.target.value })}
                placeholder="Sujet (booking, presse, boutique, soutien…)"
                data-testid="contact-subject-input"
                className={inputCls}
              />
              <textarea
                required
                rows={7}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                placeholder="Votre message"
                data-testid="contact-message-input"
                className={inputCls}
              />
              <button
                type="submit"
                disabled={sending}
                data-testid="contact-submit-button"
                className="inline-flex items-center gap-2.5 bg-jm-amber text-jm-ink px-8 py-4 text-sm font-medium tracking-wide hover:bg-jm-gold transition-colors duration-300 disabled:opacity-60"
              >
                {sending ? "Envoi…" : "Envoyer le message"}
                <Send size={14} />
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </main>
  );
}
